import React from 'react';
import { Field } from 'redux-form';
import { FormAutocompleteField, FormNumberField } from '../../../components/fields';
import { useQuery } from 'react-query';
import PlacesService from '../../../services/places';
import CheckboxField from '../../../components/fields/CheckboxField';
import Flight from '../Flight';
import styles from './style.module.css';

export default function Airport(props) {
  const { isLoading, data } = useQuery(props?.airport?.iata, PlacesService.airline);
  const assignProp = (prop) => {
    return ({
      ...props.value.airport,
      ...prop,
    });
  };

  return (
    <>
      {!isLoading &&
      <>
        <div className={styles.checkboxNoFlight}>
          <CheckboxField
            label="I don't have flight number"
            value={props.value?.airport?.noFlight}
            onChange={(value) => props.onChange(assignProp({ noFlight: value }))}
          />
        </div>
        <div className={styles.airport}>
          {
            !props?.value?.airport?.noFlight &&
            <>
              <Flight
                airlines={data}
                value={props.value?.airport?.flight}
                onChange={(value) => props.onChange(assignProp({ flight: value }))}
                fromCity={props?.value?.address?.city}
                noFlight={props?.value?.airport?.noFlight}
              />
              <Field
                label="Terminal"
                component={FormAutocompleteField}
                name="routePoints[0].airport.autocompleteTerminal"
                options={data.filter(item => item.name === props.value?.airport?.flight?.airline?.name)}
                getOptionLabel={(option) => option?.terminal || ''}
              />
            </>
          }
          {
            props?.value?.airport?.noFlight &&
            <Field
              label="Terminal"
              component={FormNumberField}
              name="routePoints[0].airport.terminal"
            />
          }
        </div>
        {
          !!props.value?.airport?.noVerifiedFlight &&
          <div className={styles.noVerifiedContainer}>
            <span className={styles.noVerifiedFlight}>Your flight could not be verified</span>
          </div>
        }
      </>
      }
    </>
  );
}
